var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrestRemovebgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.58402695 1.53248049 6.02850134 3.6674601 8.8125 6.375 C9.62332031 7.14585938 10.43414062 7.91671875 11.26953125 8.7109375 C13 11 13 11 12.94921875 12.9453125 C11.2927251 16.53097366 9.33329809 19.91672834 7.375 23.34375 C3.63579366 30.56721679 3.87456361 39.55084491 5.8359375 47.3046875 C9.38136087 56.65603908 15.03616579 63.1137706 24.140625 67.30859375 C32.096727 70.26706025 42.37699603 70.35463349 50.375 67.5 C57.55421196 64.10183967 64.00427937 58.73905777 67.2265625 51.36328125 C68.87435288 46.32836619 69.92027337 41.18268782 71 36 C76.94 36 82.88 36 89 36 C89.515625 38.454375 90.03125 40.90875 90.5625 43.4375 C93.02371912 53.81546605 97.68326089 60.00701756 106.69140625 65.80859375 C114.81738793 70.00220528 124.05352507 70.32939935 132.91796875 68.34765625 C141.98422514 65.07255898 148.82457858 58.65833512 153 50 C156.19252535 41.87254991 156.40145923 32.68883107 153.25 24.5 C151.95550635 21.66974506 150.49345551 19.15459622 148.6875 16.625 C147 14 147 14 147.0859375 12.1640625 C148.41349751 9.02103582 150.51310007 7.12918157 152.9375 4.75 C153.83339844 3.85796875 154.72929687 2.9659375 155.65234375 2.046875 C158 0 158 0 160 0 C165.18836564 6.00817233 169.28662935 12.54494698 172 20 C172.52207031 21.43085937 172.52207031 21.43085937 173.0546875 22.890625 C176.04947484 32.7412478 175.73648529 44.14254926 173 54 C171.66876643 56.41817892 170.33777284 58.65432565 168.8125 60.9375 C150.36630765 88.61051956 149.92428225 132.13380726 156.0390625 163.59375 C158.56460137 175.63903057 162.0826001 187.3420333 166 199 C164.10807525 199.98669759 162.21128022 200.9640602 160.3125 201.9375 C159.25675781 202.48277344 158.20101562 203.02804688 157.11328125 203.58984375 C154.33765953 204.8470576 151.99727874 205.56069569 149 206 C141.32145911 189.58966704 137.14858753 171.92789318 135 154 C134.9057373 153.22664307 134.81147461 152.45328613 134.71435547 151.65649414 C132.26470435 129.70823361 133.98842992 107.46259359 139 86 C138.236875 86.28875 137.47375 86.5775 136.6875 86.875 C135.470625 87.24625 134.25375 87.6175 133 88 C132.2575 88.2371875 131.515 88.474375 130.75 88.71875 C118.97368219 91.73463627 106.14293076 87.41116049 95.73046875 81.78125 C90.04465554 78.07204997 84.77903367 73.66855051 81 68 C77.61983365 69.12672212 77.11013182 69.89237929 75 72.625 C66.29959678 82.80283018 54.03317709 87.61690002 40.9375 88.875 C34.29795978 89.19923948 27.06578154 89.03289077 21 86 C21.17390259 86.92111572 21.17390259 86.92111572 21.35131836 87.86083984 C21.88440246 90.69809407 22.41097852 93.53652089 22.9375 96.375 C23.11990234 97.34050781 23.30230469 98.30601563 23.49023438 99.30078125 C28.87353022 128.46845694 25.86596107 157.13317631 18.58544922 185.64306641 C17.64907387 189.41277769 16.82605078 193.20473443 16 197 C15.34 197 14.68 197 14 197 C13.67 199.64 13.34 202.28 13 205 C9.97680647 206.31741179 8.78571426 205.92824489 5.58203125 204.85546875 C4.32033951 204.31133936 3.06389153 203.75491704 1.8125 203.1875 C1.17119141 202.91357422 0.52988281 202.63964844 -0.13085938 202.35742188 C-4.86320455 200.27359089 -4.86320455 200.27359089 -6 198 C-5.53442383 196.14672852 -5.53442383 196.14672852 -4.70703125 193.87890625 C-4.40821045 193.03602051 -4.10938965 192.19313477 -3.80151367 191.32470703 C-3.3119519 189.95741455 -3.3119519 189.95741455 -2.8125 188.5625 C10.23120983 150.5682819 11.82686408 104.27721218 -5 67 C-6.47758129 64.40020506 -8.04255126 61.87992565 -9.64453125 59.35546875 C-16.02699076 48.26433594 -15.26784047 35.26879474 -14 23 C-13.34 23 -12.68 23 -12 23 C-11.83757813 21.68515625 -11.83757813 21.68515625 -11.671875 20.34375 C-10.11581431 12.59963402 -5.28062801 5.74656578 0 0 Z ",
    fill: "#141414",
    transform: "translate(48,25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.85136382 3.18845991 2.44568918 6.31439458 2.125 9.9375 C0.86823769 12.93730954 -0.21308886 13.76451131 -2.875 15.9375 C-5.73316534 16.73686616 -8.01051905 16.69557476 -10.875 15.9375 C-13.84718476 13.91388485 -15.4168346 12.40021438 -16.50390625 8.9296875 C-17.02333116 5.96623169 -17.33581768 3.70552947 -15.75 1.0625 C-10.47488896 -2.10256662 -5.70443959 -3.23251577 0 0 Z ",
    fill: "#242424",
    transform: "translate(177.875,63.0625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.50648931 1.51708563 3.69429133 2.38858267 5 5 C4.60771923 9.05356796 3.91952532 12.83291017 1.375 16.0625 C-2.14599151 17.45236507 -5.33606744 17.89240338 -9 17 C-12.28826203 14.12277073 -13.74931432 12.22835983 -14.625 7.9375 C-13.79188716 4.02186963 -12.03093154 2.52577629 -9 0 C-5.84876177 -1.57561912 -3.37430208 -0.69813146 0 0 Z ",
    fill: "#232323",
    transform: "translate(90,62)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 2.0625 3 2.0625 5 5 C5.69151325 9.30274909 5.51557405 11.20945312 3.125 14.875 C0.61333682 17.38666318 -0.29384163 17.92153796 -3.8125 18.3125 C-7.7307645 17.92835642 -9.21293267 16.70743683 -12 14 C-13.3899408 11.2201184 -13.18488204 9.0813674 -13 6 C-10.81202928 -0.05899583 -5.96965303 -1.11495465 0 0 Z ",
    fill: "#232323",
    transform: "translate(132,196)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 0.99 2.66 1.98 3 3 C-0.00229182 4.91813089 -2.52846619 6.23596585 -6 7 C-5.04882866 5.8274869 -4.08882991 4.66212985 -3.125 3.5 C-2.59132812 2.8503125 -2.05765625 2.200625 -1.5078125 1.53125 C-0.76144531 0.77328125 -0.76144531 0.77328125 0 0 Z ",
    fill: "#606060",
    transform: "translate(206,25)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.60080151 4.00200378 0.29279692 7.04556236 -1 11 C-1.33 11 -1.66 11 -2 11 C-2.05399736 9.54207116 -2.09279177 8.08357288 -2.125 6.625 C-2.15980469 5.40683594 -2.15980469 5.40683594 -2.1953125 4.1640625 C-2 2 -2 2 0 0 Z ",
    fill: "#707070",
    transform: "translate(67,202)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.18975773 3.28463659 2.99806563 6.20696275 4 10 C3.01 10 2.02 10 1 10 C0.37542727 6.56484998 0 3.50935186 0 0 Z ",
    fill: "#6A6A6A",
    transform: "translate(52,69)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 2 2 4 3 6 C1.02 6.99 -0.96 7.98 -3 9 C-2.01 6.03 -1.02 3.06 0 0 Z ",
    fill: "#5F5F5F",
    transform: "translate(117,71)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DBDBDB",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CCCCCC",
    transform: "translate(0,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E3E3E3",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrestRemovebgPreview);
export default __webpack_public_path__ + "static/media/brest-removebg-preview.3dd8f9932c6e8cbb790998d6c1b90add.svg";
export { ForwardRef as ReactComponent };